module.exports = __webpack_public_path__ + "img/BLANCO_Support.907c478c.png";